import React, { useEffect, useState } from "react";
import "./purposive-agents.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { color, useTheme } from "@mui/system";
import { tokens } from "../../../theme";
import { Container } from "react-bootstrap";

const PurposiveAgents: React.FC = () => {
  const [resetToggle, setResetToggle] = useState("default");
  const [query, setQuery] = useState("");
  const [generatedResult, setGeneratedResult] = useState("");
  const [uploadFile, setUploadFile] = useState(false);
  const [textareaToggling, setTextareaToggling] = useState(false);

  const [prompt, setPrompt] = useState("");
  const [scenario, setScenario] = useState("");

  const handleQuery = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuery(event.target.value);
  };

  const handlePrompt = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPrompt(event.target.value);
  };

  const handleScenario = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setScenario(event.target.value);
  };

  const handleSubmit = async () => {
    console.log(resetToggle + ":    " + "Query: " + query);
    console.log(resetToggle + ":    " + "Prompt: " + prompt);
    console.log(resetToggle + ":    " + "Scenario: " + scenario);
    // setQuery("");
    let payload;
    if (resetToggle === "extract_text") {
      setUploadFile(true);
      payload = JSON.stringify({
        query: query,
        filename: "",
      });
    } else if (resetToggle === "file_exporter") {
      setUploadFile(true);

      payload = JSON.stringify({
        query: query,
        filename: "",
        output_file_format: "",
      });
    } else if (resetToggle === "excel_csv_interact") {
      payload = JSON.stringify({
        query: query,
        file: "",
        filename: "",
      });
    } else if (resetToggle === "jd_generator") {
      payload = JSON.stringify({
        query: query,
        title: "jobTitle",
        location: "location",
        role: "jobRole",
        industry: "industryType",
        experience: "experienceRequired",
        skill: "skillRequired",
      });
    } else if (resetToggle === "prompt_reviewer") {
      payload = JSON.stringify({
        prompt: prompt,
        scenario:scenario,
      });
    } else if (resetToggle === "prompt_generator") {
      payload = JSON.stringify({
        scenario:scenario,
      });
    } else {
      payload = JSON.stringify({
        query: query,
      });
    }

    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      };
      const result = await (
        await fetch(
          `https://cddgenaidev.azurewebsites.net/api/purposive-agent/${resetToggle}`,
          options
        )
      ).text();
      if (result) {
        console.log("result", result);
        setGeneratedResult(result);
      }
    } catch (err: any) {
      console.log("ERROR :::", err);
    }
  };

  const handleClear = () => {
    setQuery("");
  };

  let theme = useTheme();
  let color = theme.palette.mode;

  return (
    <div
      style={{ padding: "16px" }}
      data-bs-theme={color}
      className={`purposive-agents-page${
        color == "dark" ? "dark-theme" : "light-theme"
      }`}
    >
      <Container>
        <div className="title-main">
          <h2 className="heading">Purposive Agents</h2>
        </div>

        <br></br>

        <div>
          <select required onChange={(e) => setResetToggle(e.target.value)}>
            <option
              value="default"
              style={{ color: "#4d4d4d" }}
              disabled={resetToggle !== "default"}
            >
              Select Purposive Agent
            </option>
            <option value="query_generator">Query Generator</option>
            <option value="document_creation">Document Creation</option>
            <option value="code_check">Code Check</option>
            <option value="automation">Automation</option>
            <option value="mathematics">Mathematics</option>
            <option value="data_obfuscation">Data Obfuscation</option>
            <option value="code_generator">Code Generator</option>
            <option value="extract_text">Extract Text</option>
            <option value="file_exporter">File Explorer</option>
            <option value="excel_csv_interact">Excel CSV Interact</option>
            <option value="jd_generator">JD Generator</option>
            <option value="knowledge_base">Knowledge Base</option>
            <option value="image_simularity">Image Simularity</option>
            <option value="prompt_reviewer">Prompt Reviewer</option>
            <option value="prompt_generator">Prompt Generator</option>
          </select>

          {resetToggle === 'extract_text' ? (
            <>
              <input type="file" />
            </>
          ) : (resetToggle === 'prompt_reviewer' ? (
                <>
                  <textarea
                    placeholder="Enter Your Prompt"
                    onChange={handlePrompt}
                    value={prompt}
                    ></textarea>
                  
                  <textarea
                    placeholder="Enter The Scenario"
                    onChange={handleScenario}
                    value={scenario}
                    ></textarea>
                </>
          ) : (resetToggle === 'prompt_generator' ? (
                <>
                  <textarea
                    placeholder="Enter The Scenario"
                    onChange={handleScenario}
                    value={scenario}
                    ></textarea>
                </>
          ) : 
          (
            <>
              <textarea
                placeholder="Enter Your Query"
                onChange={handleQuery}
                value={query}
              ></textarea>
            </>
          )))}

          <br></br>

          <div className="button-container">
            <button
              className="btn btn-primary"
              style={{ width: "fit-content" }}
              onClick={handleSubmit}
            >
              Submit
            </button>
            <button
              className="btn btn-secondary"
              style={{ width: "fit-content" }}
              onClick={handleClear}
            >
              Clear
            </button>

            {resetToggle === "default" && (
              <button className="btn btn-dark" style={{ width: "fit-content" }}>
                Reset File
              </button>
            )}
          </div>

          {generatedResult && (
            <div
              style={{
                padding: "16px",
                marginTop: "16px",
                borderRadius: "8px",
                border: "1px solid #ddd",
              }}
            >
              {generatedResult}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default PurposiveAgents;
